import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Stateの初期状態
const initialState = {
    error_flag: false,
    error_message: "",
    return_flag: false,
    no_return_flag: false,
    close_flag: false,
};

// Sliceを生成する
const slice = createSlice({
    name: "ErrorHandler",
    initialState,
    reducers: {
        errorHandler_set: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                (action) => action.type.endsWith("/fulfilled"),
                (state, action) => {
                    const payload = action.payload;

                    let color = "red";

                    if (action.type.match(/get|Get/g)) {
                        color = "#00ff0d";
                    }
                    if (action.type.match(/post|Post/g)) {
                        color = "#f830d7";
                    }
                    console.debug("");
                    console.debug(
                        `%c▼▼▼▼▼▼▼｢${action.type}｣のリクエスト▼▼▼▼▼▼▼▼▼▼▼▼▼▼%c`,
                        `font-weight: bold; color: ${color};`,
                        ""
                    );
                    console.debug(action.meta.arg);
                    // console.debug("｢" + action.type + "｣の戻り値");
                    console.debug(`%c｢${action.type}｣のの戻り値%c`, `font-weight: bold; color: ${color};`, "");
                    console.debug(payload);
                    console.debug(
                        `%c▲▲▲▲▲▲▲｢${action.type}｣の通信終了▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲%c`,
                        `font-weight: bold; color: ${color};`,
                        ""
                    );
                    if (
                        (payload.result == 2 || payload.result == "NG") &&
                        payload.error_message &&
                        !payload.disabled_error
                    ) {
                        state.error_flag = true;
                        state.error_message = payload.error_message;
                    }
                }
            )
            .addMatcher(
                (action) => action.type.endsWith("/rejected") && action.meta.arg.method !== "get",
                (state, action) => {
                    if(!action.payload?.hasOwnProperty("message")) state.no_return_flag = true;
                }
            )
            .addMatcher(
                (action) => action.type.endsWith("/rejected") && action.meta.arg.method === "get" && !action.type.startsWith("メンバーフォーム取得") && !action.type.startsWith("GetEnableDate"),
                (state, action) => {
                    state.return_flag = true;
                }
            );
    },
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { errorHandler_set } = slice.actions;
